import React from 'react';
import { formatUSD } from '../lib/format';

export default function RevenueModels({ pharmaAnnual, aiMonthly, consortiumPerInst }) {
  return (
    <div style={containerStyle} data-testid="revenue-models">
      <ModelRow
        title="Pharma Partnership"
        amount={formatUSD(pharmaAnnual)}
        unit="per year"
        accent="var(--accent)"
      />
      <ModelRow
        title="AI / Tech Licensing"
        amount={formatUSD(aiMonthly)}
        unit="per month"
        accent="var(--navy)"
      />
      <ModelRow
        title="Research Consortium"
        amount={formatUSD(consortiumPerInst)}
        unit="per institution / year"
        accent="var(--amber)"
      />
    </div>
  );
}

function ModelRow({ title, amount, unit, accent }) {
  return (
    <div style={{ ...rowStyle, borderLeftColor: accent }}>
      <div style={rowHeaderStyle}>{title}</div>
      <div style={amountStyle}>{amount}</div>
      <div style={unitStyle}>{unit}</div>
    </div>
  );
}

const containerStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
};

const rowStyle = {
  background: 'var(--surface)',
  border: '1px solid var(--line)',
  borderLeft: '4px solid transparent',
  borderRadius: '8px',
  padding: '16px 20px',
};

const rowHeaderStyle = {
  fontSize: '13px',
  fontWeight: 600,
  color: 'var(--ink2)',
  textTransform: 'uppercase',
  letterSpacing: '0.04em',
  marginBottom: '4px',
};

const amountStyle = {
  fontSize: '24px',
  fontWeight: 700,
  color: 'var(--ink)',
};

const unitStyle = {
  fontSize: '13px',
  color: 'var(--muted)',
};
